<div class="pull-right text-muted">
  <a ng-click="demarcacao.goToHistory()">
    <i class="icon-updated" aria-hidden="true"></i> Histórico
  </a>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2 class="f-size-22">
    <strong ng-show="demarcacao.drawPolygon.id">EDITANDO DEMARCAÇÃO DE ÁREA</strong>
    <strong ng-hide="demarcacao.drawPolygon.id">NOVA DEMARCAÇÃO DE ÁREA</strong>
  </h2>
</div>



<input type="file" file-input ng-model="demarcacao.kmlFile" ng-change="demarcacao.changeFile(demarcacao.kmlFile)" class="hidden" id="kmlInput">

<form id="draw_polygon_form" name="draw_polygon_form" novalidate ng-submit="demarcacao.save(draw_polygon_form)">

  <div>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': draw_polygon_form.descricao.$invalid}">
        <input class="form-control" placeholder="Descrição" ng-model="demarcacao.drawPolygon.descricao" type="text" id="descricao" name="descricao" autocomplete="off" required>
        <p class="help-block" ng-show="draw_polygon_form.descricao.$dirty && draw_polygon_form.descricao.$error.required">Informe uma Descrição</p>
      </div>
    </div>

    <!-- Safra -->
    <div class="width-100">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.safra" theme="bootstrap" id="safra" name="safra" required  ng-change="demarcacao.reloadCamposProducao()" >
          <ui-select-match placeholder="Safra">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="safra in $root.safras | orderBy: '-descricao' | filter: $select.search">
            <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Cor -->
    <div class="width-100">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.cor" theme="bootstrap" id="cor" name="cor" search-enabled="false">
          <ui-select-match placeholder="Cor">
            <span class="color-selection" ng-style="{'background-color': $select.selected}"></span>
          </ui-select-match>
          <ui-select-choices repeat="cor in demarcacao.cores">
            <span class="color-selection" ng-style="{'background-color': cor}"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Tipo  -->
    <div class="width-100">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.tipo" theme="bootstrap" id="tipo" name="tipo" required ng-change="demarcacao.loadMaquinas()">
          <ui-select-match placeholder="Tipo">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="tipo.id as tipo in demarcacao.tipos | filter: $select.search">
            <span class="form-group" ng-bind-html="tipo.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Tipo campo de produção -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'campo_de_producao'">
      <div class="form-group">
        <span> <i class="pull-right fa fa-spinner fa-spin" ng-show="demarcacao.drawPolygon.loading"></i> </span>
        <ui-select ng-model="demarcacao.drawPolygon.relacaoCampo" theme="bootstrap" id="relacaoCampo" name="relacaoCampo" ng-hide="demarcacao.drawPolygon.loading" required>
          <ui-select-match allow-clear="true" placeholder="Campo de Produção">{{$select.selected.descricao | capitalize | characters:30}}</ui-select-match>
          <ui-select-choices repeat="relacao in demarcacao.relacaoCampos | orderBy: 'descricao' | filter: $select.search">
            <span class="form-group" ng-bind-html="relacao.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <!-- Cultura -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'cultivar' || demarcacao.drawPolygon.tipo == 'empreendimento'">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.atividade" ng-change="demarcacao.changeAtividade(demarcacao.drawPolygon.atividade)" theme="bootstrap" id="atividade" name="atividade" required>
          <ui-select-match allow-clear="true" placeholder="Cultura">{{$select.selected.descricao | capitalize | characters:30}}</ui-select-match>
          <ui-select-choices repeat="atividade in demarcacao.atividades | orderBy: 'descricao' | filter: $select.search">
            <span class="form-group" ng-bind-html="atividade.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <!-- Tipo Cultivar -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'cultivar' || demarcacao.drawPolygon.tipo == 'empreendimento'">
      <div class="form-group">
        <small class="text-danger" ng-show="demarcacao.cultivares && !demarcacao.cultivares.length">Não existem cultivares para a cultura, não é possível fazer o registro.</small>
        <ui-select ng-show="!demarcacao.cultivares || demarcacao.cultivares.length" ng-model="demarcacao.drawPolygon.cultivar" theme="bootstrap" id="cultivar" name="cultivar" required>
          <ui-select-match allow-clear="true" placeholder="Cultivar">{{$select.selected.descricao | characters:30}}</ui-select-match>
          <ui-select-choices repeat="cultivar in demarcacao.cultivares | orderBy: 'descricao' | filter: $select.search | limitTo: 50">
            <span class="form-group" ng-bind-html="cultivar.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Tipo Plantio - Operador -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'plantio_operador'">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.operador" theme="bootstrap" id="operador" name="operador" required>
          <ui-select-match allow-clear="true" placeholder="Operador">{{$select.selected.nome | characters:30}}</ui-select-match>
          <ui-select-choices repeat="operador.id as operador in demarcacao.operadores | filter: $select.search | limitTo: 50">
            <span class="form-group" ng-bind-html="operador.nome | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Empreendimento -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'empreendimento'">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.empreendimento" theme="bootstrap" id="empreendimento" name="empreendimento" required>
          <ui-select-match allow-clear="true" placeholder="Empreendimento">{{$select.selected.descricao | characters:30}}</ui-select-match>
          <ui-select-choices repeat="empreendimento.id as empreendimento in demarcacao.empreendimentos | filter: $select.search | limitTo: 50">
            <span class="form-group" ng-bind-html="empreendimento.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <div ng-if="demarcacao.drawPolygon.tipo =='plantio_operador'" class="width-100">
      <div class="form-group" ng-class="{'has-error': draw_polygon_form.larguraPlantio.$invalid}">
        <div class="input-group">
          <span class="input-group-addon p-xxs">
            Largura do plantio
          </span>
          <input class="form-control p-xxs" ng-model="demarcacao.drawPolygon.larguraPlantio"
                 type="number" id="larguraPlantio" name="larguraPlantio" ng-change="demarcacao.recalculateAreas()" required>
          <span class="input-group-addon p-xxs">m</span>
        </div>
        <p class="help-block" ng-show="draw_polygon_form.larguraPlantio.$dirty && draw_polygon_form.larguraPlantio.$error.required">Informe a largura de plantio</p>
      </div>
    </div>

    <!-- Máquina -->
    <div class="width-100" ng-if="demarcacao.drawPolygon.tipo == 'uso_maquina'">
      <div class="form-group">
        <ui-select ng-model="demarcacao.drawPolygon.maquina" theme="bootstrap" id="maquina" name="maquina" required>
          <ui-select-match allow-clear="true" placeholder="Máquina">{{$select.selected.descricao | characters:30}}</ui-select-match>
          <ui-select-choices repeat="maquina.id as maquina in demarcacao.maquinas | filter: $select.search | limitTo: 50">
            <span class="form-group" ng-bind-html="maquina.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>


    <div class="width-100">
      <h4>Demarcações</h4>

      <div class="text-center" ng-show="!demarcacao.drawPolygon.polygons.length">
        <small>Nenhuma área</small>
      </div>
      <div class="list-group">
        <div class="list-group-item padding-5" ng-repeat="polygon in demarcacao.drawPolygon.polygons track by $index">
          <div class="pull-left" style="line-height: 30px; vertical-align: middle;" ng-if="polygon.area">
            {{polygon.area | convertM2ToHa | number:2}} ha
          </div>
          <div class="pull-left" style="line-height: 30px; vertical-align: middle;" ng-if="!polygon.area">
            Ponto {{$index + 1}}          
          </div>

          <div class="pull-right">
            <span ng-if="demarcacao.drawPolygon.tipo !== 'uso_maquina'" class="btn p-xxs text-danger" ng-click="demarcacao.removePolygon($index)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
            <span class="btn p-xxs" ng-click="demarcacao.centerPolygon(polygon)">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </span>
          </div>

          <div class="clearfix"></div>
        </div>

        <h5 class="pull-right" ng-show="demarcacao.drawPolygon.polygons.length">
          Total: {{demarcacao.drawPolygon.areaTotal || 0| convertM2ToHa | number: 2}} ha
        </h5>
      </div>

      <p ng-if="demarcacao.drawPolygon.tipo !== 'uso_maquina'" class="text-center padding-top-5">
        <a prevent-event href="#" onclick="$('#kmlInput').click()" class="width-100" style="display: inline-block;">
          <small><i class="fa fa-upload" aria-hidden="true"></i> Importar demarcação de Arquivo KML/GPX</small>
        </a>
      </p>
    </div>

    <br><br>

    <div class="btn-group btn-group-justified">
      <div class="btn-group">
        <button class="btn btn-primary" type="submit"
                ng-disabled="draw_polygon_form.$invalid || demarcacao.loadingSave || demarcacao.loadingDelete || demarcacao.disableSaving">
          Salvar
          <span ng-show="demarcacao.loadingSave">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
      <div class="btn-group" ng-if="demarcacao.drawPolygon.id">
        <button class="btn btn-danger" type="button" ng-click="demarcacao.delete()"
                ng-disabled="demarcacao.loadingSave || demarcacao.loadingDelete">
          Excluir
          <span ng-show="demarcacao.loadingDelete">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</form>
